import React from "react"
import {
  Container,
  Image,
  Info,
  Title,
  Button,
} from "../styles/CategoryItemStyle"
import { Link } from "react-router-dom"

const CategoryItem = ({ item }) => {
  return (
    <Container>
      <Link to={`/products/${item.name}`}>
        <Image src={item.image} />
        <Info>
          <Title>{item.name}</Title>
          <Button>See Category</Button>
        </Info>
      </Link>
    </Container>
  )
}

export default CategoryItem
